import { Button, Col, Flex, Input, Row, Typography } from 'antd';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { TaskDetailsJsonBody } from './task-details-json-body';
import { Title } from './title';

// Оптимизированная функция для получения текста и количества строк
const getTextAndLines = (text) => {
    const value = (text || '').trim();
    return {
        value,
        lines: value ? value.split('\n').length : 0
    };
};

export const TaskDetails = () => {
    const task = useSelector(state => state.applications.currentApplicationData);
    const maxRows = 4;
    const [fullOutcome, setFullOutcome] = useState(false);
    const [fullDetails, setFullDetails] = useState(false);

    const { value: outcome, lines: outcomeLines } = useMemo(
        () => getTextAndLines(task?.eventresult),
        [task?.eventresult]
    );
    const { value: details, lines: detailsLines } = useMemo(
        () => getTextAndLines(task?.body),
        [task?.body]
    );

    const borderless = {
        details: detailsLines < maxRows || fullDetails,
        outcome: outcomeLines < maxRows || fullOutcome
    }

    return (
        <Row style={{ width: '100%' }}>

            <Col span={task?.division ? 12 : 24} style={{ marginBottom: 16 }}>
                <Title>Тема</Title>
                <Typography.Text style={{ fontSize: 20 }}>{task?.topic}</Typography.Text>
            </Col>
            {!!task?.division && (
                <Col xs={24} sm={12} style={{ marginBottom: 16 }}>
                    <Title>Ответственный отдел</Title>
                    <Typography.Text style={{ fontSize: 20 }}>{task?.division}</Typography.Text>
                </Col>
            )}
            <Col span={24} style={{ marginBottom: 16 }}>
                <Title>Подробности</Title>
                {!!task?.jsonBody ? (
                    <TaskDetailsJsonBody more={fullDetails} />
                ) : (
                    <Input.TextArea
                        variant={borderless.details ? 'borderless' : 'outlined'}
                        autoSize={{ minRows: 1, maxRows: fullDetails ? 2000 : maxRows }}
                        value={details.replace(/\n{3,}/g, '\n\n').trim()}
                        readOnly
                        style={{ fontSize: 20, padding: borderless.details ? 0 : '4px 11px', overflowY: 'auto' }}
                        placeholder="Подробностей нет"
                    />
                )}
                <Flex justify="flex-end" align="center" style={{ display: !task?.jsonBody && (detailsLines < maxRows) ? 'none' : 'flex' }}>
                    <Button type='text' size='small' onClick={() => { setFullDetails(!fullDetails) }}>
                        {fullDetails ? 'свернуть' : 'раскрыть полностью'}
                    </Button>
                </Flex>
            </Col>
            {outcome && (
                <Col span={24}>
                    <Title>Результат</Title>
                    <Input.TextArea
                        variant={borderless.outcome ? 'borderless' : 'outlined'}
                        autoSize={{ minRows: 1, maxRows: fullOutcome ? 2000 : maxRows }}
                        value={outcome}
                        readOnly
                        style={{ fontSize: 20, padding: borderless.outcome ? 0 : '4px 11px', overflowY: 'auto' }}
                        placeholder="Результат выполнения задачи"
                    />
                    <Flex justify="flex-end" align="center" style={{ display: outcomeLines < maxRows ? 'none' : 'flex' }}>
                        <Button type='text' size='small' onClick={() => { setFullOutcome(!fullOutcome) }}>
                            {fullOutcome ? 'свернуть' : 'раскрыть полностью'}
                        </Button>
                    </Flex>
                </Col>
            )}
        </Row>
    )
}